import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
//import { AuthConfig } from '@michelin/auth';

export interface EnvConfiguration {
  ENVIRONMENT: string;
  FORGEROCK_ISSUER: string;
  FORGEROCK_CLIENTID: string;
  oauth2_scopes: string;
  oauth2_redirect_uri: string;
  FORGEROCK_LOGOUT_REDIRECT: string;
  BACKEND_URL: string;
  BACKEND_SUB_PATH: string;
}

interface CustomWindow extends Window {
  // add you custom properties and methods
  dynamicConf: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {
  public static loadDynamicConf(): void {
    EnvConfigurationService.configuration = {
      ...EnvConfigurationService.configuration,
      ...(window as CustomWindow & typeof globalThis).dynamicConf
    };
  }

  // This is default configuration, these values are public and can be retreive in production.
  // They are overriden with config.json provided with a k8s configmap. See config.json in .k8s overlays folder
  public static configuration: EnvConfiguration = {
    ENVIRONMENT: 'local',
    FORGEROCK_ISSUER: 'https://login-dev-fed.aze.michelin.com/am/oauth2/realms/root/realms/API-HAP',
    FORGEROCK_CLIENTID: '',
    oauth2_scopes: 'openid profile email',
    oauth2_redirect_uri: `${window.location.origin}`,
    FORGEROCK_LOGOUT_REDIRECT: `${window.location.origin}/?loggedout`,
    BACKEND_URL: environment.apiUrl,
    // BACKEND_URL: 'https://cardealer-api.dk8snca2-private.aze.michelin.com',
    BACKEND_SUB_PATH: '/api'
  };

  public static getEnv(): string {
    return EnvConfigurationService.configuration.ENVIRONMENT;
  }
}

EnvConfigurationService.loadDynamicConf();
